var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.96,
    height: 15.441,
    viewBox: "0 0 21.96 15.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M20.03,76H1.93A1.933,1.933,0,0,0,0,77.93V89.511a1.933,1.933,0,0,0,1.93,1.93h18.1a1.932,1.932,0,0,0,1.93-1.93V77.93A1.932,1.932,0,0,0,20.03,76Zm-.27,1.287-7.415,7.376a1.93,1.93,0,0,1-2.731,0L2.2,77.287ZM1.287,89.249V78.193l5.56,5.531Zm.914.905,5.558-5.523.946.941a3.217,3.217,0,0,0,4.548,0l.947-.942,5.558,5.523Zm18.472-.905-5.56-5.525,5.56-5.531Z",
    transform: "translate(0 -76)",
    fill: "#373737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7c023a6ee10c530a2ed8eac948840b91.svg";
export { ForwardRef as ReactComponent };